import React from 'react';
import PropTypes from 'prop-types';
import LocaleText from '../LocaleText';
import history from '../../history';
import { formatAmount } from '../../helpers/formatingHelpers';
import BioBadge from '../../../svg/environment-badge.svg';
import AwardBadge from '../../../svg/award-badge.svg';

class PenSlide extends React.Component {
    constructor() {
        super();
        this.renderBadges = this.renderBadges.bind(this);
    }

    renderBadges() {
        const { badges, openBadgePopup } = this.props;
        const typeImages = {
            environment: BioBadge,
            award: AwardBadge,
        };

        if (!badges) {
            return null;
        }

        // loop over all badges and create a structure like {'environment': [1, 2], 'new': [3]}
        let usedTypes = {};
        let generalBadges = [];
        badges.forEach(badge => {
            if (usedTypes.hasOwnProperty(badge.type)) {
                usedTypes[badge.type].push(badge.id);
            } else {
                usedTypes[badge.type] = [badge.id];
            }
        });

        if (usedTypes.hasOwnProperty('general')) {
            generalBadges = usedTypes.general.map(id => {
                return badges.find(badge => badge.id === id);
            });

            delete usedTypes.general;
        }

        return (
            <div className="pen-badges">
                {generalBadges.map(badge => (
                    <img
                        src={badge.image}
                        alt={badge.name}
                        key={badge.id}
                        className="pen-badge general"
                    />
                ))}
                {Object.keys(usedTypes).map(type => (
                    <img
                        src={typeImages[type]}
                        alt=""
                        onClick={() => openBadgePopup(usedTypes[type])}
                        key={type}
                        className="pen-badge group"
                        data-badges={`${usedTypes[type].join(',')}`}
                    />
                ))}
            </div>
        );
    }

    render() {
        const { pen, touched, lang } = this.props;
        const {
            images,
            min_order_amounts: minOrderAmounts,
            name,
            description,
            category,
            slug,
        } = pen;

        const penUrl = `/${lang}/${pen.static === true ? 'static-pen' : 'pen'}/${slug}`;

        return (
            <div className={`${slug} pen-slide swiper-slide`} data-slug={pen.slug}>
                <div className="pen-slide__head">
                    <p className="pen-slide__category">{category.name}</p>
                    <h2 className="pen-slide__title">{name}</h2>
                </div>

                <picture>
                    <source
                        media="(min-width: 768px)"
                        srcSet={`${images.large} 2x, ${images.medium} 1x`}
                    />
                    <source media="(max-width: 767px)" srcSet={images.small} />
                    <img src={images.medium} alt={name} className="pen-slide__image" />
                </picture>

                <div className="pen-slide__card">
                    <div className="pen-slide__badge-container">{this.renderBadges()}</div>

                    <p className="pen-slide__description">{description}</p>

                    {touched ? (
                        <button className="btn" onClick={() => history.push(penUrl)}>
                            <LocaleText textKey="overview.cta.secondary" />
                        </button>
                    ) : (
                        <button className="btn is-primary" onClick={() => history.push(penUrl)}>
                            <LocaleText textKey="overview.cta.primary" />
                        </button>
                    )}

                    <p className="pen-slide__min-order-note">
                        <LocaleText
                            textKey="overview.min.order.amount.standard"
                            args={[
                                formatAmount(minOrderAmounts.template),
                            ]}
                        />&nbsp;
                        { typeof minOrderAmounts.individual === "number" && minOrderAmounts.individual > 0 && (
                            <LocaleText
                                textKey="overview.min.order.amount.individual"
                                args={[
                                    formatAmount(minOrderAmounts.individual),
                                ]}
                            />
                        )}
                    </p>
                </div>
            </div>
        );
    }
}

PenSlide.propTypes = {
    pen: PropTypes.shape({
        category: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
        }),
        description: PropTypes.string,
        min_order_amounts: PropTypes.shape({
            template: PropTypes.number,
            individual: PropTypes.number,
        }),
        name: PropTypes.string,
        slug: PropTypes.string,
    }).isRequired,
    touched: PropTypes.bool,
    badges: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            image: PropTypes.string,
            name: PropTypes.string,
        })
    ),
    openBadgePopup: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
};

PenSlide.defaultProps = {
    touched: false,
    badges: [],
};

export default PenSlide;
